import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateCounter',
})
export class TruncateCounterPipe implements PipeTransform {
  transform(number: number): string {
    if (typeof number !== 'number') {
      return '';
    }
    if (number >= 1000000000) {
      return `${Math.floor(number / 1000000000)}<i>B</i>`;
    }
    if (number >= 1000000) {
      return `${Math.floor(number / 1000000)}<i>M</i>`;
    }
    if (number >= 1000) {
      return `${Math.floor(number / 1000)}<i>K</i>`;
    }
    return number.toString();
  }
}
